import type { ClinicalFindingsAccumulator } from "../mappers";
import { antibioticVmpIdsSet, antimalarialVmpIdsSet } from "./vmp-sets";

export enum DrugGuidanceDeviation {
  ACT_PRESCRIPTION_NEGATIVE_MALARIA_TEST = "ACT_PRESCRIPTION_NEGATIVE_MALARIA_TEST",
  NO_ACT_PRESCRIPTION_POSITIVE_MALARIA_TEST = "NO_ACT_PRESCRIPTION_POSITIVE_MALARIA_TEST",
  ANTIBIOTIC_NO_BACTERIAL_DIAGNOSIS = "ANTIBIOTIC_NO_BACTERIAL_DIAGNOSIS",
  NONE = "NONE",
}

// TODO: Add check for recent test results
export const checkGuidelinesDeviation = ({
  vmpId,
  recentRelevantResources,
  antibioticVmpIds = antibioticVmpIdsSet,
}: {
  vmpId: string;
  recentRelevantResources: ClinicalFindingsAccumulator;
  antibioticVmpIds?: Set<string>;
}): DrugGuidanceDeviation => {
  if (!vmpId) {
    return DrugGuidanceDeviation.NONE;
  }
  if (
    antibioticVmpIds.has(vmpId) &&
    recentRelevantResources.bacterialDiagnoses.length === 0
  ) {
    return DrugGuidanceDeviation.ANTIBIOTIC_NO_BACTERIAL_DIAGNOSIS;
  }
  // if (
  //   !antimalarialVmpIdsSet.has(vmpId) &&
  //   recentRelevantRxResources.positiveMalarialResults.length > 0
  // ) {
  //   return DrugGuidanceDeviation.NO_ACT_PRESCRIPTION_POSITIVE_MALARIA_TEST;
  // }
  if (
    antimalarialVmpIdsSet.has(vmpId) &&
    recentRelevantResources.negativeMalarialResults.length > 0 &&
    recentRelevantResources.positiveMalarialResults.length === 0
  ) {
    return DrugGuidanceDeviation.ACT_PRESCRIPTION_NEGATIVE_MALARIA_TEST;
  }
  return DrugGuidanceDeviation.NONE;
};
